import { defineComponent as _defineComponent } from 'vue'
import CarouselArrowButton from 'JS/components/carousels/CarouselArrowButton.vue';
import UiButton from 'JS/components/UiButton.vue';
import { AnalyticsPromoAttrs } from 'JS/utilities/analytics';
import { cssVarsToStyleString } from 'JS/dxp/utilities/css-vars';
import { ItemCarouselWidget } from 'JS/dxp/types/widgets/item-carousel-widget';
import { StoryAndItemCarouselLink } from 'JS/dxp/types/widgets/computed';
import { StoryCarouselWidget } from 'JS/dxp/types/widgets/story-carousel-widget';
import { useDxpColors } from 'JS/dxp/composables/colors';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutA',
  props: {
    widget: null,
    link: null,
    promoAttrs: null,
    items: null
  },
  setup(__props: any) {

const props = __props as {
	widget: StoryCarouselWidget | ItemCarouselWidget;
	link?: StoryAndItemCarouselLink | null;
	promoAttrs?: AnalyticsPromoAttrs | null;
	items: any[];
}



const {
	backgroundColor,
	textColor,
	textIsWhite,
	uiButtonColor,
} = useDxpColors(() => props.widget.backgroundColor);


return { __sfc: true,props, backgroundColor, textColor, textIsWhite, uiButtonColor, CarouselArrowButton, UiButton, cssVarsToStyleString }
}

})